export default function Text(input) {
  const {
    viesValidation = false,
    validateAgainst = null,
    identifier,
    type,
    required = false,
    hidden = false,
    client = false,
    value,
    aggregation = false
  } = input

  return {
    value: '',
    identifier,
    name: value || null,
    type,
    isRequired: required,
    hidden,
    client,
    viesValidation,
    validateAgainst,
    aggregation
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/helpers/text.js